module.exports = __webpack_public_path__ + "img/138.5.95500f5e.png";